import React from 'react';

class ResumoAnualForm extends React.Component {

    render() {
        return(
            <div>
                <p id="resumo-anual-txt">
                    Informe o centro de custo e o ano das movimentações financeiras.
                </p><br /><br />
                <form id="resumo-anual-form">
                    <select value={ this.props.centro } onChange={ this.props.changeCentro }>
                        <option value="Centro">Centro</option>
                        { this.props.centros.map((item, i) =>
                            <option key={ i } value={ item.id }>{ item.nome }</option> ) }
                    </select><br />
                    <select value={ this.props.ano } onChange={ this.props.changeAno }>
                        <option value="Ano">Ano</option>
                        { this.props.anos.map((item, i) =>
                            <option key={ i } value={ item }>{ item }</option> ) }
                    </select><br /><br />
                    <button type="button" id="resumo-anual-voltar-btn" onClick={ this.props.voltar }>
                        Voltar
                    </button>
                    <button type="button"
                        id="resumo-anual-visualizar-btn"
                        onClick={ this.props.visualizar }
                        disabled={ this.props.disabled }>
                        Visualizar Resumo
                    </button>
                    <button type="button"
                        id="resumo-anual-baixar-btn"
                        onClick={ this.props.baixar }
                        disabled={ this.props.disabled }>
                        Baixar Planilha
                    </button><br /><br />
                </form>
            </div>
        );
    }

}

export default ResumoAnualForm;

